import React, { RefObject, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { alterThreadByExpertMode } from 'src/presentation/components/pages/sidekick/threads/actions/threadActions';
import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import ExpertModeModal, { ExpertModeModalRef } from './ExpertModeModal';
import { NewThreadModalRef } from 'src/presentation/components/pages/sidekick/threads/components/NewThreadModal';
import {
  selectCurrentThread,
  selectThreadMeta,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import SidekickThreadsActions from 'src/presentation/components/pages/sidekick/threads/SidekickThreadsActions';

const Actions = ({
  root,
  newThreadModalRef,
  toggleEnabledHandler,
}: {
  root: string;
  newThreadModalRef: RefObject<NewThreadModalRef>;
  toggleEnabledHandler;
}) => {
  const expertModeModalRef = React.useRef<ExpertModeModalRef>(null);
  const dispatch = useDispatch();

  const currentThread = useSelector(selectCurrentThread);
  const threadMeta = useSelector(selectThreadMeta);

  const json = useMemo(() => {
    return JSON.stringify(currentThread.nextData, null, 2);
  }, [currentThread]);

  const handleClick = () => {
    expertModeModalRef.current?.show({
      title: 'Expert Mode',
      json,
      subscribe: (json: unknown) => {
        const alteredThread = { ...currentThread, nextData: JSON.parse(json as string) };
        dispatch(alterThreadByExpertMode(alteredThread));
      },
    });
  };

  return (
    <>
      <StyledButton type={ButtonTypes.SECONDARY}>
        <StyledSidekickThreadsRowActions
          item={threadMeta}
          className="sidekick-row-actions"
          newThreadModalRef={newThreadModalRef}
          root={root}
          isEditorPage={true}
          handleExpertModeClick={handleClick}
          toggleEnabledHandler={toggleEnabledHandler}
          hasActions={threadMeta.hasActions}
        />
      </StyledButton>
      <ExpertModeModal ref={expertModeModalRef} />
    </>
  );
};

export default Actions;

const StyledSidekickThreadsRowActions = styled(SidekickThreadsActions)`
  visibility: visible;
  position: relative;
  top: 2px;
`;

const StyledButton = styled(Button)`
  padding: 8px;
`;
